import Immutable, { merge } from 'seamless-immutable'
import { startOfMonth, endOfMonth } from 'date-fns'

export const SORT_UPDATE = 'users/SORT_UPDATE'
export const FILTER_UPDATE = 'users/FILTER_UPDATE'

const initialState = Immutable({
  startDate: startOfMonth(new Date()).toISOString(),
  endDate: endOfMonth(new Date()).toISOString(),
  sort: 'created_at',
  asc: false
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SORT_UPDATE:
      return merge(state, {
        sort: action.sort,
        asc: action.asc
      })

    case FILTER_UPDATE:
      return merge(state, {
        startDate: action.startDate,
        endDate: action.endDate
      })

    default:
      return state
  }
}

export const setListSort = ({ sort, asc }) => async dispatch => {
  dispatch({ type: SORT_UPDATE, sort, asc })
}

export const setListFilter = ({ startDate, endDate }) => async dispatch => {
  dispatch({ type: FILTER_UPDATE, startDate, endDate })
}

export const clearListFilter = () => async dispatch => {
  dispatch({
    type: FILTER_UPDATE,
    startDate: startOfMonth(new Date()).toISOString(),
    endDate: endOfMonth(new Date()).toISOString()
  })
}
